/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledButtonGroupList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
`;
